var isDev = process.env.NODE_ENV === "development";
// isDev = false;
const config = {
  baseURL: isDev
    ? "http://127.0.0.1:8000/api"
    : "https://einsteinseedsalumni.com/einsteinseedsalumni/public/api",

  // Add more config values here if needed
  appName: "DeepRead AI",
  timeout: 5000, // in ms
};

export default config;
